import { call, put, takeLatest } from "redux-saga/effects";
import {
GET_REVIEWRATINGS,
ADD_REVIEWRATINGS,
UPDATE_REVIEWRATINGS,
DELETE_REVIEWRATINGS,
GET_REVIEWRATINGS_SUCCESS,
ADD_REVIEWRATINGS_SUCCESS,
UPDATE_REVIEWRATINGS_SUCCESS,
DELETE_REVIEWRATINGS_SUCCESS
} from "../../redux/actions/actionType";
import api from "../../apis/api";

// api function.
function getReviewRatingApi()  {
    // api for get review list
   const response = api.dbReviewRating().GetRatingList();
    return response;
  }
  function addReviewRatingApi(formData) {
    // api for add  review.
    const response = api.dbReviewRating().AddEditRating(formData);
    return response;
  }
  function updateReviewRatingApi(formData) {
    // api for update  review.
    const response = api.dbReviewRating().AddEditRating(formData);
    return response;
  }
  function deleteReviewApi(delId) {
    // api for delete  review.
    const response = api.dbReviewRating().DeleteRating(delId);
    return response;
  }
  
export function* handleGetReviewRating() {
    try {
      const response = yield call(getReviewRatingApi);
      yield put({ type: GET_REVIEWRATINGS_SUCCESS, payload: response.data });
    } catch (error) {

    }
  }
  export function* handleAddReviewRating({ payload }) {
    try {
      const respone = yield call(addReviewRatingApi, payload);
      yield put({ type: ADD_REVIEWRATINGS_SUCCESS, payload: payload });
      const response = yield call(getReviewRatingApi);
      yield put({ type: GET_REVIEWRATINGS_SUCCESS, payload: response.data });
    } catch (error) {

    }
  }
  export function* handleUpdateReviewRating({ payload }) {
    try {
      let formData = payload;
      const respone = yield call(updateReviewRatingApi, formData);
      yield put({ type: UPDATE_REVIEWRATINGS_SUCCESS, payload: formData });
      const response = yield call(getReviewRatingApi);
      yield put({ type: GET_REVIEWRATINGS_SUCCESS, payload: response.data });
    } catch (error) {

    }
  }
  export function* handleDeleteReviewRating({ payload }) {
    try {
      yield call(deleteReviewApi, payload);
      yield put({ type: DELETE_REVIEWRATINGS_SUCCESS, payload: payload });
    } catch (error) {

    }
  }
  
  // watach function.
  export function* ReviewRatingWatchFun() {
    yield takeLatest(GET_REVIEWRATINGS, handleGetReviewRating);
    yield takeLatest(ADD_REVIEWRATINGS, handleAddReviewRating);
    yield takeLatest(UPDATE_REVIEWRATINGS, handleUpdateReviewRating);
    yield takeLatest(DELETE_REVIEWRATINGS, handleDeleteReviewRating);
  }